// export const passwordFormErrors = [
//     {
//       key: 'required',
//       message: 'passwordRequired'
//     },
//     {
//       key: 'minLength',
//       message: 'passwordMinLength'
//     },
//     {
//       key: 'maxLength',
//       message: 'passwordMaxLength'
//     },
//     {
//       key: 'uppercase',
//       message: 'passwordOneUpperCase'
//     },
//     {
//       key: 'lowercase',
//       message: 'passwordOneLowerCase'
//     },
//     {
//       key: 'number',
//       message: 'passwordOneNumber'
//     },
//     {
//       key: 'specialCharacter',
//       message: 'passwordOneSpecial'
//     },
//     {
//       key: 'repeatedCharacters',
//       message: 'passwordIdentical'
//     },
//     {
//       key: 'commonWords',
//       message: 'passwordCommon'
//     }
//   ];

  import { keyMessage } from "../../models/common";

export const nameErrors: keyMessage[] = [
  { key: 'required', message: 'nameRequired' },
  { key: 'minlength', message: 'nameMinLength' },
  { key: 'maxlength', message: 'nameMaxLength' },
  { key: 'invalidCharacters', message: 'nameOnlyAlphabets' },
];

export const emailErrors: keyMessage[] = [
  {
    key: 'required',
    message: 'emailRequired',
  },
  {
    key: 'email',
    message: 'invalidEmail',
  },
  {
    key: 'pattern',
    message: 'invalidEmail',
  },
  {
    key: 'maxlength',
    message: 'emailMaxLength',
  },
];

export const passwordFormErrors: keyMessage[] = [
  {
    key: 'minLength',
    message: 'passwordMinLength',
  },
  {
    key: 'maxLength',
    message: 'passwordMaxLength',
  },
  {
    key: 'uppercase',
    message: 'passwordOneUpperCase',
  },
  {
    key: 'lowercase',
    message: 'passwordOneLowerCase',
  },
  {
    key: 'number',
    message: 'passwordOneNumber',
  },
  {
    key: 'specialCharacter',
    message: 'passwordOneSpecial',
  },
];
